import React from 'react';
import PageBody from '../../components/pagebody/PageBody';
import Report from './report/Report';

export default function ReportsSection() {
	return (
		<PageBody>
			<Report />
		</PageBody>
	)
}